import React            from "react";
import {SectionWrapper} from "../../../shared/Styles/Wrappers";
import {TextBox}        from "../TextBox/textBox";

import {Container, TextBoxesSection, Title} from "./styles";

export const Marketing = ({data}) => {
  return (
    <Container>
      <SectionWrapper>
        <Title>Co osiągnęliśmy?</Title>
      </SectionWrapper>
      <TextBoxesSection>
        <TextBox marketing data={data.textboxes.first}/>
        <TextBox marketing bigText data={data.textboxes.second}/>
        <TextBox marketing bigText data={data.textboxes.third}/>
      </TextBoxesSection>
    </Container>
  );
};
